import React from 'react';
import { LogoSVG } from '../Icons';
import { WA_NUMBER, WA_DEFAULT_MSG } from '../../data/constants';
import { waLink } from '../../utils/whatsapp';
import './Footer.css';

const Footer: React.FC = () => (
  <footer>
    <div className="footer-grid">
      <div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.8rem' }}>
          <LogoSVG size={80} />
          <div className="logo-text">
            <span className="logo-name">Souza &amp; Villa</span>
            <span className="logo-tagline">Abogadas</span>
          </div>
        </div>
        <p className="footer-brand-desc">
          Estudio jurídico especializado en derecho laboral, familia y migratorio. Concepción y Lomas Coloradas.
        </p>
      </div>
      <div>
        <div className="footer-col-title">Navegación</div>
        <ul className="footer-links">
          <li><a href="#socias">Equipo</a></li>
          <li><a href="#areas">Áreas de práctica</a></li>
          <li><a href="#agendar">Agendar consulta</a></li>
          <li><a href="#servicios">Servicios</a></li>
          <li><a href="#finiquito">Finiquito</a></li>
          <li><a href="#estado">Soy Cliente</a></li>
        </ul>
      </div>
      <div>
        <div className="footer-col-title">Información</div>
        <ul className="footer-links">
          <li><a href="#faq">Preguntas frecuentes</a></li>
          <li><a href="#oficinas">Oficinas</a></li>
          <li><a href="#trabaja">Trabaja con nosotros</a></li>
        </ul>
      </div>
      <div>
        <div className="footer-col-title">Contacto</div>
        <ul className="footer-links">
          <li><a href={waLink(WA_DEFAULT_MSG)} target="_blank" rel="noopener noreferrer">WhatsApp</a></li>
          <li><a href="mailto:contacto@svabogadas.cl">contacto@svabogadas.cl</a></li>
          <li><a href="#oficinas">Concepción</a></li>
          <li><a href="#oficinas">Lomas Coloradas</a></li>
        </ul>
      </div>
    </div>
    <div className="footer-bottom">
      <span>© 2026 Souza &amp; Villa Abogadas. Todos los derechos reservados.</span>
      <span>Concepción, Región del Biobío, Chile</span>
    </div>
  </footer>
);

export default Footer;
